import { getGridStringOperators, GridColDef, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro';
import { CustomGridFilterInputMultipleValue } from 'components/grid/panel/filterPanel/CustomGridFilterInputMultipleValue';
import { t } from 'i18next';

export const getModifiedGridStringOperators = (): GridFilterOperator[] => {
  const gridStringOperators = getGridStringOperators();

  addOppositeOperator(gridStringOperators, 'contains', { value: 'doesNotContain', label: t('doesNotContainFilter') });
  addOppositeOperator(gridStringOperators, 'equals', { value: 'doesNotEqual', label: t('doesNotEqualFilter') });
  addOppositeOperator(gridStringOperators, 'isAnyOf', {
    value: 'isNotAnyOf',
    label: t('isNotAnyOfFilter'),
    InputComponent: CustomGridFilterInputMultipleValue,
  });

  return gridStringOperators.map(operator => {
    if (operator.value === 'isAnyOf') {
      return {
        ...operator,
        InputComponent: CustomGridFilterInputMultipleValue,
      };
    }
    return operator;
  });
};

type NewOperator = Pick<GridFilterOperator, 'value'> & Partial<Exclude<GridFilterOperator, 'value'>>;

/// Adds an operator after the one with the given name that applies the opposite filter.
const addOppositeOperator = (operators: GridFilterOperator[], toInvert: string, newOperator: NewOperator) => {
  // Skip the operator if it already exists (which may happen when we upgrade MUI and get a newer set of operators)
  if (operators.some(o => o.value === newOperator.value)) {
    return;
  }

  const toInvertIndex = operators.findIndex(o => o.value === toInvert);
  if (toInvertIndex === -1) {
    console.error(`Could not find operator '${toInvert}' to invert`);
    return;
  }

  const toInvertOperator = operators[toInvertIndex];

  // Create the new operator by first overriding any of the original properties with the user input, and then inverting
  // both filter functions.
  const toAddOperator = {
    ...toInvertOperator,
    ...newOperator,
  } satisfies GridFilterOperator;

  const originalGetApplyFilterFn = toInvertOperator.getApplyFilterFn;
  toAddOperator.getApplyFilterFn = (filterItem: GridFilterItem, column: GridColDef) => {
    const originalApplyFilterFn = originalGetApplyFilterFn(filterItem, column);
    if (originalApplyFilterFn === null) {
      return null;
    }

    return (params: any): boolean => {
      return !originalApplyFilterFn(params);
    };
  };

  if (toInvertOperator.getApplyFilterFnV7 !== undefined) {
    const originalGetApplyFilterFnV7 = toInvertOperator.getApplyFilterFnV7;
    toAddOperator.getApplyFilterFnV7 = (filterItem: GridFilterItem, column: GridColDef) => {
      const originalApplyFilterFnV7 = originalGetApplyFilterFnV7(filterItem, column);
      if (originalApplyFilterFnV7 === null) {
        return null;
      }

      return (value, row, column, apiRef): boolean => {
        return !originalApplyFilterFnV7(value, row, column, apiRef);
      };
    };
  }

  operators.splice(toInvertIndex + 1, 0, toAddOperator);
};
